import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/index/index.vue'),
      },
      {
        path: 'cloudSpace',
        component: () => import('@/views/index/cloudSpace.vue'),
        children: [
          {
            path: 'detail/:type',
            component: () => import('@/views/index/cloudSpace/detail.vue'),
          },
          {
            path: 'recycleBin',
            component: () => import('@/views/index/cloudSpace/recycleBin.vue'),
          },
          {
            path: 'shareFiles',
            component: () => import('@/views/index/cloudSpace/shareFiles.vue'),
          },
        ]
      },
      {
        path: 'dynamic',
        component: () => import('@/views/index/dynamic.vue'),
        children: [
          {
            path: 'uploadList',
            component: () => import('@/views/index/dynamic/uploadList.vue'),
          },
          {
            path: 'overList',
            component: () => import('@/views/index/dynamic/overList.vue'),
          },
          {
            path: 'downloadList',
            component: () => import('@/views/index/dynamic/downloadList.vue'),
          },
        ]

      },
      {
        path: 'setting',
        component: () => import('@/views/index/setting.vue'),
        children: [
          {
            path: 'resetPassword',
            component: () => import('@/views/index/setting/resetPassword.vue'),
          },
          {
            path: 'login',
            component: () => import('@/views/index/setting/login.vue'),
          },
        ]
      }
    ]
  },
  {
    path: `/share`,
    component: () => import('@/views/share.vue'),
    children: [
      {
        path: ':code',
        components: {
          pc: () => import('@/views/share/pcShare.vue'),
          phone: () => import('@/views/share/phoneShare.vue')
        },
      },
    ]
  },
  {
    path: `/invite`,
    component: () => import('@/views/invite.vue'),
    children: [
      {
          path: 'file/:code',
        components: {
          pc: () => import('@/views/invite/pcInvite.vue'),
          phone: () => import('@/views/invite/phoneIncite.vue')
        },
      },
      {
        path: 'chooseCompany',
        components: {
          phone: () => import('@/views/invite/phone/chooseCompany.vue')
        },
      },
      {
        path: 'newUser',
        components: {
          phone: () => import('@/views/invite/phone/newUser.vue')
        },
      }
    ]
  },
  {
    path: '/shareSet',
    component: () => import('@/views/share/set.vue'),
    redirect: 'shareSet/login',
    children: [
      {
        path: '/shareSet/login',
        component: () => import('@/views/share/set/login.vue'),
      },
      {
        path: '/shareSet/register',
        component: () => import('@/views/share/set/register.vue'),
      },
      {
        path: 'perfectInformation',
        component: () => import('@/views/share/set/perfectInformation.vue'),
      },
      {
        path: '/shareSet/retrievePassword',
        component: () => import('@/views/share/set/retrievePassword.vue'),
      },
      {
        path: 'setPassword',
        component: () => import('@/views/share/set/setPassword.vue'),
      },
    ]
  },
  {
    path: '/invitePeople',
    name: 'invitePeople',
    component: () => import('@/views/invitePeople.vue'),
    children: [
      {
        path: 'index/:code',
        components: {
          pc: () => import('@/views/invitePeople/index/pc.vue'),
          phone: () => import('@/views/invitePeople/index/phone.vue')
        },
      },
      {
        path: 'setInfo',
        components: {
          pc: () => import('@/views/invitePeople/userInfo/pc.vue'),
          phone: () => import('@/views/invitePeople/userInfo/phone.vue')
        },
      },
      {
        path: 'apply',
        components: {
          pc: () => import('@/views/invitePeople/apply/pc.vue'),
          phone: () => import('@/views/invitePeople/apply/phone.vue')
        },
      }
    ]
  },
  {
    path: '/backstage',
    name: 'backstage',
    component: () => import('@/views/backstage.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/backstage/index.vue'),
      },
      {
        path: 'log',
        component: () => import('@/views/backstage/log.vue'),
      },
      {
        path: 'member',
        component: () => import('@/views/backstage/member.vue'),
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }

]



const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {

  let __token__ = to.query.token || '';
  if (__token__) {
    window.localStorage.setItem('ddbes-token', __token__);
  }
  next();
});


export default router
